module.exports = __webpack_public_path__ + "static/media/1002248.ab5f1084.png";